import { ThunkDispatch } from "redux-thunk";
import { Http } from "../../../helpers/axois";
import {
    CREATE_CSS_ASSET,
    FETCH_ASSET_FAILURE,
    FETCH_ASSET_SUCCESS,
    FETCH_ASSET,
    CREATE_IMAGE_ASSET,
    DELETE_IMAGE_ASSET,
    CREATE_FONT_ASSET,
    UPDATE_CSS_ASSET_URL,
    DELETE_CSS_ASSET_URL,
    FontType,
    DELETE_FONT_ASSET,
    CREATE_JSON_ASSET,
    DELETE_JSON_ASSET,
} from "./types";
import { RootState } from "..";
import { pushToast } from "../toast/actions";
import {handleCustomFontFace} from "../../../pages/apps/forms/formBuilder/PropertiesPanel/layout-components/helpers/handleCustomFontFace"

export function fetchAllStaticAssetsByFiletype(data: any) {
    return (dispatch: any) => {
        dispatch({
            type: FETCH_ASSET,
            data: []
        })
        return new Promise((resolve, reject) => {
            try {
                Http.post("/static-asset/all", {
                    "appId": data.appId,
                    "filetype": data.filetype,
                    orgId: data.orgId
                }).subscribe((res: any) => {
                        if (res.ok) {
                            const initalState = {
                                css: {},
                                images: {},
                                fonts: {},
                                json: {}
                            }
                            const payload = res.assets.reduce((a: any, c: any) => {
                                if(c.id){
                                    if (c.filetype === "css") {
                                        a.css[c.id] = c;
                                    } else if (c.filetype === "image") {
                                        a.images[c.id] = c;
                                    } else if (c.filetype === "font") {
                                        if (!validateIsGoogleFont(c.url)) {
                                            let updatedFont = handleCustomFontFace(c.filename);
                                            let fontProperties:any = {}
                                            if(updatedFont?.fontWeight){
                                                fontProperties["weight"] = updatedFont?.fontWeight.toString();
                                            }
                                            if(updatedFont?.fontStyle){
                                                fontProperties["style"] = updatedFont?.fontStyle;
                                            }
                                            const font = new FontFace(
                                                updatedFont.fontName, 
                                                `url(${c.url}) format(${updatedFont.format})`, fontProperties
                                            );
                                            
                                            font.load().then((loadedFont) => {
                                                document.fonts.add(loadedFont);
                                            }).catch((error) => {
                                                console.error('Font failed to load:', error);
                                            });
                                            c.filename = updatedFont.baseName;
                                        }
                                        a.fonts[c.id] = c;
                                    } else if (c.filetype === "json") {
                                        a.json[c.id] = c;
                                    }
                                }
                                return a
                            }, initalState);
                            dispatch({
                                type: FETCH_ASSET_SUCCESS,
                                data: payload
                            })
                            resolve(true);
                        } else {
                            dispatch({
                                type: FETCH_ASSET_FAILURE,
                                data: []
                            })
                            reject("Error fetching assets");
                        }
                    }, (err) => {
                        if (err === "Forbidden") {
                            dispatch(pushToast({ type: 'error', message: "Not Authorized: Error fetching static assets" }))
                            dispatch({
                                type: FETCH_ASSET_FAILURE,
                                data: []
                            })
                        }
                        reject(err);
                    })
            } catch (error) {
                console.error(error)
                dispatch({
                    type: FETCH_ASSET_FAILURE,
                    data: []
                });
                reject(error);
            }
        });
    }
}

const validateIsGoogleFont = (fontUrl: string) => {
    // Check if the URL includes "fonts.googleapis.com" (Google Fonts domain)
    if (fontUrl.includes("fonts.googleapis.com")) {
      return true;
    } else {
      return false;
    }
};

function getFontDetails(url: string, fontName: string) {
    // const fileNameWithExtension = url.substring(url.lastIndexOf('/') + 1);
    const [updatedFontName, extension] = fontName.split('.');
    let format;
    switch (extension) {
      case 'ttf':
        format = 'TrueType';
        break;
      case 'otf':
        format = 'opentype';
        break;
      case 'woff':
        format = 'WOFF';
        break;
      case 'woff2':
        format = 'WOFF2';
        break;
      case 'eot':
        format = 'Embedded OpenType';
        break;
      case 'svg':
        format = 'SVG Font';
        break;
      default:
        format = 'Unknown Format';
    }
    return { updatedFontName, format };
}

export function createNewCSSAsset(data: any) {
    return {
        type: CREATE_CSS_ASSET,
        data
    }
}

export function updateCssAssetUrlById(data: any) {
    return {
        type: UPDATE_CSS_ASSET_URL,
        data
    }
}

export function deleteCssAssetUrlById(data: any) {
    return {
        type: DELETE_CSS_ASSET_URL,
        data
    }
}

// Image actions
export function createNewImageAsset(data: any) {
    return {
        type: CREATE_IMAGE_ASSET,
        data
    }
}

// deleteImageAssetById will delete the selected image static-asset from redux 
export function deleteImageAssetById(data: { id: string }) {
    return {
        type: DELETE_IMAGE_ASSET,
        data
    }
}

// Font actions
export function createNewFontAsset(data: any) {
    return {
        type: CREATE_FONT_ASSET,
        data
    }
}

export function enlistGoogleFont(orgId: string, appId: string, filename: string, fontUrl: string) {
    return async (dispatch: ThunkDispatch<RootState, any, any>) => {
        dispatch({
            type: FETCH_ASSET,
            data: []
        })
        try {
            const data: any = await Http.post("/static-asset/create", {
                appId,
                filename,
                filetype: "font",
                url: fontUrl,
                orgId
            }).toPromise();

            dispatch({
                type: CREATE_FONT_ASSET,
                data
            })
        } catch (error) {
            console.error(error)
        }
    }
}

export function deleteFontAssetById(orgId: string, appId: string, fontId: string, filename: string) {
    return async (dispatch: ThunkDispatch<RootState, any, any>) => {
        const endpoint = `/static-asset`;
        try {
            const payload: any = {
                appId,
                orgId,
                id: fontId,
                filename,
            };
            await Http.put(endpoint, payload).toPromise();
            dispatch({
                type: DELETE_FONT_ASSET,
                data: { id: fontId }
            })
            return { ok: true, error: undefined }
        } catch (err) {
            if (err === "Forbidden") {
                dispatch(pushToast({ type: 'error', message: "Not Authorized: Please request owner of this organization to provide access" }))
            }
            console.error(err);
            if (err instanceof Error) {
                return { ok: false, error: err.message }
            } else {
                return { ok: false, error: "Something went wrong" }
            }
        }
    }
}

export function createNewJsonAsset(data: any) {
    return {
        type: CREATE_JSON_ASSET,
        data
    }
}

export function deleteJsonAssetById(data: { id: string }) {
    return {
        type: DELETE_JSON_ASSET,
        data
    }
}